import { render, staticRenderFns } from "./allocahis.vue?vue&type=template&id=0471c522&scoped=true&"
import script from "./allocahis.vue?vue&type=script&lang=js&"
export * from "./allocahis.vue?vue&type=script&lang=js&"
import style0 from "./allocahis.vue?vue&type=style&index=0&id=0471c522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471c522",
  null
  
)

export default component.exports